var map = {
	"./black/qiangchai2.png": "Y0OX",
	"./blue/qiangchai2.png": "wHg9",
	"./white/qiangchai2.png": "Lzd0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aO7m";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/qiangchai2\.png$
// module id = aO7m
// module chunks = 24